import React, { FunctionComponent } from "react";
import { Box } from "@material-ui/core";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Button, Header } from "components/UI";

interface Props {
  onCreate: () => void;
  loading?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    rightContainer: {
      display: "flex",
      justifyContent: "flex-end"
    }
  })
);

/**
 * Header for the Email Templates list. Mirrors the `HeaderComponent` pattern
 * used by Superadmins/Clients — title + right-aligned primary button — but
 * omits the search bar (search is out of scope for the MVP per CUD-4860).
 */
export const EmailTemplatesHeader: FunctionComponent<Props> = props => {
  const classes = useStyles();

  return (
    <Header
      title="Email Templates"
      rightElements={
        <Box className={classes.rightContainer}>
          <Button
            label="Create Template"
            onClick={props.onCreate}
            loading={props.loading}
            disabled={props.loading}
          />
        </Box>
      }
    />
  );
};

export default EmailTemplatesHeader;
